<template>
    <span class="favorite-wrapper">
        <button
            id="dashboard.favorite.toggle"
            class="favorite-button"
            :class="{ dark: dark }"
            @click="onClick"
        >
            <FavoriteIconFilled v-if="favorite" class="filled" />
            <FavoriteIconOutlined v-else class="outlined" />
        </button>
    </span>
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator';
import { AngularDirective } from '@/vue/decorators/angular-interop';
import { AngularLocaleBundle } from '@/angular-bridge/modules/i18n';
import FavoriteIconFilled from '@/vue/components/shared/favorite/FavoriteIconFilled.vue';
import FavoriteIconOutlined from '@/vue/components/shared/favorite/FavoriteIconOutlined.vue';
import VrmInfoTooltip from '@/vue/components/shared/VrmInfoTooltip';

@Component({
    components: { FavoriteIconOutlined, FavoriteIconFilled, VrmInfoTooltip },
    emits: ['change'],
})
@AngularDirective('vrm-favorite-installation-button')
@AngularLocaleBundle('dashboard')
export default class FavoriteIcon extends Vue {
    @Prop({
        type: Boolean,
        default: false,
    })
    favorite;

    @Prop({
        type: Boolean,
        default: false,
    })
    dark;

    // eslint-disable-next-line no-unused-vars
    onClick(e) {
        this.$emit('click', !this.favorite);
    }
}
</script>

<style scoped>
.favorite-wrapper {
    display: inline-block;
}

.favorite-button {
    cursor: pointer;
    background: none;
    color: inherit;
    border: none;
    font: inherit;
    outline: inherit;
    height: 3.5rem;
    width: 3.5rem;
    display: flex;
    justify-content: center;
    align-items: center;
}

.favorite-button .outlined {
    fill: rgb(var(--grey));
    transition: all 0.2s ease-in-out;
}

.favorite-button:hover .outlined,
.favorite-button.dark:hover .outlined {
    fill: rgb(var(--blue));
}

.favorite-button.dark .outlined {
    fill: rgb(var(--grey-light));
}

.favorite-button .filled {
    fill: rgb(var(--blue));
}
</style>
